import React, { lazy, Suspense } from "react";
import { LazyLoader } from "../../../../assets/loaders";

const LazyComponent = lazy(() => import("./Designations"));

export default function Designations() {
  return (
    <Suspense fallback={<LazyLoader />}>
      <LazyComponent />
    </Suspense>
  );
}
